import { SortFilter } from "../services/utils/pagination";

const mapSortFilter = ({ id, order }: SortFilter) => id + ":" + order;
const mapSortFilterArray = (filter: SortFilter[]) => filter.map(mapSortFilter).join(",");

export { mapSortFilter, mapSortFilterArray };
